import { render, staticRenderFns } from "./Grid3.vue?vue&type=template&id=8b8d3c94&scoped=true"
import script from "./Grid3.vue?vue&type=script&lang=ts"
export * from "./Grid3.vue?vue&type=script&lang=ts"
import style0 from "./Grid3.vue?vue&type=style&index=0&id=8b8d3c94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8d3c94",
  null
  
)

export default component.exports